

































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class CarryOverInvoiceView extends Vue {
  public items: Common.CarryOverInvoice[] = new Array(0);
  public params: Common.InvoiceQuery = new Common.InvoiceQuery(true);
  public exportQuery = new Common.InvoiceExportQuery('繰越請求',this.params,true,Common.SalesPurchaseFlags.Sales);
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'invoiceNo', text: '請求書番号' },
    { value: 'closingDate', text: '請求締日' },
    { value: 'counterpart', text: '得意先' },
    { value: 'dueDate', text: '入金予定日' },
    { value: 'provisionalClosingDate', text: '仮締日' },
    { value: 'refNo', text: '請求管理番号' },
    { value: 'segment', text: '部門' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;  
  @Prop() public invoiceNo:string;

  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  public calcUtil: Common.CalcUtil = new Common.CalcUtil();
  public hasLicenseCurrency: boolean = false;

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;    
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 120),
      new Common.GridItemConfiguration('請求書番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 170),
      new Common.GridItemConfiguration('請求締日', 100),
      new Common.GridItemConfiguration('得意先', 180),
      new Common.GridItemConfiguration('請求通貨', 100,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('今回請求額', 120),   
      new Common.GridItemConfiguration('入金予定日', 100),         
      new Common.GridItemConfiguration('請求締', 100),      
      new Common.GridItemConfiguration('請求方法', 150),
      new Common.GridItemConfiguration('決済条件', 150),              
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('請求管理番号', 150),

      new Common.GridItemConfiguration('前回請求額', 150),
      new Common.GridItemConfiguration('入金額', 150),
      new Common.GridItemConfiguration('繰越金額', 150),                
      new Common.GridItemConfiguration('今回税抜金額', 150),
      new Common.GridItemConfiguration('今回消費税額', 150),
      new Common.GridItemConfiguration('今回税込金額', 150),

  
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),

    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;

    // 検索条件を設定する
    if(this.invoiceNo) {
      this.params.invoiceNo = this.invoiceNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
  }

  public async onCreate(obj: Common.Invoice) {
    const workflows = this.$api.formatter.getOptions('workflow_carryOverInvoice');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //請求明細タブのリロード
    (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();       
  }

  public get workflowRequired() {
    return this.$api.formatter.getOptions('workflow_carryOverInvoice').length != 0;
  }

  public isEditableState(state: Common.InvoiceStatus):boolean{
    if(state == Common.InvoiceStatus.CarryOverWaiting || state == Common.InvoiceStatus.CarryOverClosingWaiting) return true;
    else return false;
  }

  // 一覧でチェックされている請求
  public checkedInvoices: Array<Common.Invoice>= new Array(0);
  public getCheckedInvoices(){
    this.checkedInvoices = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedInvoices.push(obj);
      }
    });
  }

  // 入金処理用プロパティ
  public brSegment: Common.Segment = null;
  public brPic: string = '';
  public brWorkflowId:number = 0;
  public brCounterpart: Common.Counterpart = null;
  public brCurrencyCode: string = '';
  public brReceiptDate: Date = new Date;
  public brBankAccount: Common.BankAccount = null;
  public brExchangeRate:number = 0;
  public get brReceiptAmountFC(): number { return this.brSettlementAmountFC - this.brCommissionAmountFC; };
  public brCommissionAmountFC: number = 0;
  public brCommissionTaxFlag: boolean = false;
  public get brSettlementAmountFC(): number {
    if(this.checkedInvoices.length == 0) return 0;
    return this.checkedInvoices.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };
  public brMin(invoice:Common.Invoice): number{
    if(invoice.pendingBalanceAmountFC > 0) return 0;
    else return -99999999999.99;
  }
  public brMax(invoice:Common.Invoice): number{
    if(invoice.pendingBalanceAmountFC < 0) return 0;
    else return 99999999999.99;
  }
  public brDecimal: number = 0;

  // 入金ダイアログの表示
  public showBilledReceiptDialog() {
    this.getCheckedInvoices();

    // ダイアログ表示前バリデーション
    if(this.checkedInvoices.length == 0){
      this.$api.modal.show('', '対象の伝票を選択して下さい。', true, null);                  
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.counterpart.id != this.checkedInvoices[0].counterpart.id)).length > 0){
      this.$api.modal.show('', '得意先の異なる請求データを、同じ入金伝票にまとめることはできません。', true, null);
      return;
    }
    // if(this.checkedInvoices.filter(invoice=> (invoice.currencyCode != this.checkedInvoices[0].currencyCode)).length > 0){
    //   this.$api.modal.show('', '請求通貨の異なる請求データを、同じ入金伝票にまとめることはできません。', true, null);
    //   return;
    // }
    if(this.checkedInvoices.filter(invoice=> (invoice.segmentId != this.checkedInvoices[0].segmentId)).length > 0){
      this.$api.modal.show('', '部門の異なる請求データを、同じ入金伝票にまとめることはできません。', true, null);
      return;
    }        
    // if(this.checkedInvoices.filter(invoice=> (invoice.billedBalanceAmountFC == 0)).length > 0){
    //   this.$api.modal.show('', '請求残高のある請求データを選択して下さい。', true, null);
    //   return;
    // }
    if(this.checkedInvoices.filter(invoice=> (invoice.state & Common.InvoiceStatus.CarryOverWaiting) > Common.InvoiceStatus.Purchase).length > 0){
      this.$api.modal.show('', '前回請求データの締処理が未完了のため、この請求データは入金処理できません。', true, null);
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.state & Common.InvoiceStatus.CarryOverCompleted) > Common.InvoiceStatus.Purchase).length > 0){
      this.$api.modal.show('', '締め処理が完了しているため入金処理はできません。', true, null);
      return;
    }

    // プロパティの初期化
    this.brSegment = this.checkedInvoices[0].segment; //請求部門をセット(非表示)
    this.brPic = this.$api.auth.userId;    
    this.brWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_receivePayment');
    this.brCounterpart = this.checkedInvoices[0].counterpart;
    this.brCurrencyCode = this.checkedInvoices[0].currencyCode;
    this.brReceiptDate = this.checkedInvoices.map(invoice => invoice.dueDate).reduce((min, value) => min = (min == null || min > value) ? value : min);
    this.brBankAccount = this.checkedInvoices[0].bankAccount;
    this.brExchangeRate = 1;
    this.brCommissionAmountFC = 0;
    this.brCommissionTaxFlag = true; // 販売管理では課税固定
    this.onChangeReceiptDate();

    this.brDecimal = 0;
    const obj = this.$api.currencies.filter(obj => obj.value == this.brCurrencyCode);
    if (obj.length > 0) this.brDecimal = Number(obj[0].text);

    // ダイアログの表示
    (this.$refs.billedReceiptDialog as Components.ListDialog).items = this.checkedInvoices;
    (this.$refs.billedReceiptDialog as Components.ListDialog).items.forEach(item => item.writeoffAmountFC = item.pendingBalanceAmountFC);
    (this.$refs.billedReceiptDialog as Components.ListDialog).showDialog();
  }
  public async onChangeReceiptDate(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.brCurrencyCode;
    query.startDate = this.brReceiptDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.brExchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });
  }
  // 入金処理の実行
  public async submitBilledReceipt(list: Array<Common.Invoice>) {
    // 実行前バリデーション
    if(this.brSettlementAmountFC != list.map(invoice => invoice.writeoffAmountFC).reduce((total, value) => total += value)){
      this.$api.modal.show('', '入金額合計が決済金額となるように入力してください。', true, null);
      return;
    }
    if(list.filter(invoice => invoice.currencyCode != this.tenantSettings.currencyCode && invoice.billedBalanceAmountFC < invoice.writeoffAmountFC).length > 0){
      this.$api.modal.show('', '売掛金残高を超える入金は、システム通貨のみ可能です。', true, null);
      return;
    }

    // クエリの設定
    var query = new Common.BilledReceiptQuery();
    query.isCarryOverInvoice = true;
    query.segment = this.brSegment;
    query.pic = this.brPic;
    query.workflowId = this.brWorkflowId;
    query.counterpart = this.brCounterpart;
    query.currencyCode = this.brCurrencyCode;
    query.receiptDate = this.brReceiptDate;
    query.bankAccount = this.brBankAccount;
    query.exchangeRate = this.brExchangeRate;
    query.commissionAmountFC = this.brCommissionAmountFC;
    query.settlementAmountFC = this.brSettlementAmountFC;
    query.commissionTaxFlag = this.brCommissionTaxFlag;
    query.invoices = list;

    // 入金処理の実行
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/cash/Deposit?paymentNo={0}', (res as Common.Payment).paymentNo));      
    // });

    return this.$api.execute(query).then(res => {
      //リストリロード & 入金明細タブのリロード
      (this.$refs.mainList as Components.ListView).reload().then(()=>this.refreshPaymentList());
      var payment = res as Common.Payment;
      //this.$api.modal.show('処理結果','以下の入金伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/Deposit?paymentNo={0}',payment.paymentNo))]);
      this.$api.modal.show('処理結果','以下の入金伝票が作成されました。',false,()=>this.$router.push(String.format('/cash/Deposit?paymentNo={0}',payment.paymentNo)),[new Common.ModalLink(payment.paymentNo, String.format('/cash/Deposit?paymentNo={0}',payment.paymentNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});            
  }

  // 入金情報タブ更新用プロパティ
  public isLoading:boolean = false;
  public totalPaymentAmountFC:number = 0;
  public totalPendingAmountFC:number = 0;  
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 一覧選択時に入金情報タブを更新
  public onSelectedMain(index: number, selected: Common.Invoice) {
    this.totalPaymentAmountFC = 0;
    this.totalPendingAmountFC = 0;            
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();
  }

  // 入金情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffPendingAmountFC = 0;         
    // クエリの設定
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = (this.$refs.mainList as Components.ListView).selected.invoiceNo;
    query.isSend = false;

    // サーバーから入金情報を取得する
    this.$api.execute(query).then(res => {
      res = res as Common.LoadResult;
      this.paymentJournals = res.result;
      this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.ReceiptCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.ReceiptPostWaiting;            
          }
      });
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;            
    });
  }

  // 入金一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/Deposit?paymentNo={0}',paymentNo));
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.CarryOverInvoice){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesInvoice, sourceNo : item.invoiceNo},this.$el);
  }
  // 請求明細一覧へ遷移する
  public showInvoiceItem(invoiceNo: string) {
    this.$router.push(String.format('/sales/InvoiceItem?invoiceNo={0}', invoiceNo));
  }
}
